$(document).ready(function () {
  // Logo Slider  
  $('.featured-logo-slider').slick({
    slidesToShow: 6.7,
    slidesToScroll: 1,
    infinite: true,
    lazyLoad: 'ondemand',
    arrows: false,
    swipeToSlide: true,
    draggable: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 3500,
    cssEase: 'linear',
    pauseOnHover: false,
    pauseOnFocus: false,
    rtl: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3.4,
          speed: 2000,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4.5,
        }
      }
    ]
  });

  // Featured Products Slider
  $('.featured-products-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    rows: 1,
    infinite: true,
    speed: 300,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 2,
          prevArrow: $('.slider-button.slick-prev'),
          nextArrow: $('.slider-button.slick-next'),
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          rows: 1,
        }
      }
    ]
  });

  // Products Quality Icons Slider
  $('.product-quality-slider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    infinite: true,
    lazyLoad: 'ondemand',
    arrows: false,
    swipeToSlide: true,
    draggable: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    cssEase: 'linear',
    centerMode: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          centerPadding: '30px',
          speed: 2500,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          centerMode: true,
          centerPadding: '30px',
        }
      }
    ]
  });

  //Footer Accordian
  $(function () {
    const $headers = $('.footer-menu .footer-menu-heading');

    $headers.click(function () {
      const $this = $(this);
      $headers.not($this).removeClass('active');
      $this.toggleClass('active');
    });
  });

  // Announcement bar
  $('.top-bar__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    speed: 1000,
    lazyLoad: 'ondemand',
    infinite: true,
  });
  // Handle the quantity change
  $(document).on('click', '.quantity_block .increase-qty', function () {
    console.log("clicked");
    let productCard = $(this).parents('.quantity-form');
    let quantity = parseInt($(productCard).find('input[name="quantity"]').val());
    quantity += 1;
    $(productCard).find('input[name="quantity"]').val(quantity);
  });

  $(document).on('click', '.quantity_block .decrease-qty', function () {
    let productCard = $(this).parents('.quantity-form');
    let quantity = parseInt($(productCard).find('input[name="quantity"]').val());
    if (quantity > 1) {
      quantity -= 1;
    }
    $(productCard).find('input[name="quantity"]').val(quantity);
  });
  $(document).on('submit', 'form[data-type="add-to-cart-form"], form[name="customAddToCart"]', function (e) {
    e.preventDefault();
    const $form = $(this);

    if ($form.is('[data-printer-product]')) {
      var productUrl = $form.attr('data-product-url');
      if (productUrl) {
        window.location.href = productUrl;
      }
      return;
    }

    const formData = $form.serializeArray();
    customAddToCartProduct(formData, $form);
  });
});


function customAddToCartProduct(formData, $form) {
  let data;
  $form.find("button").attr('disabled', true);
  $form.find(".loading__spinner").removeClass('hidden');

  const hasItemsField = formData.some((field) => field.name === 'items');
  if (hasItemsField) {
    const itemsField = formData.find((field) => field.name === 'items');
    try {
      data = JSON.parse(itemsField.value);
    } catch (error) {
      console.error("Error parsing 'items' field:", error);
      $form.find("button").attr('disabled', false);
      $form.find(".loading__spinner").addClass('hidden');
      return;
    }
  } else {
    const item = {};
    formData.forEach((field) => {
      const name = field.name;
      const value = field.value;

      // Handle line item properties
      const propMatch = name.match(/^properties\[(.+)\]$/);
      if (propMatch) {
        const propName = propMatch[1];
        item.properties = item.properties || {};
        item.properties[propName] = value;
      } else {
        item[name] = value;
      }
    });

    data = [item];
  }

  const generatedFormData = {
    items: data,
    sections: ['cart-drawer', 'cart-icon-bubble'],
    sections_url: window.location.pathname,
  };

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(generatedFormData),
  })
    .then((response) => {
      if (!response.ok) {
        if ($form.find('.quantity-error').length > 0) {
          $form.find('.quantity-error').css('display', 'flex');
        }
        if ($form.siblings('.quantity-error').length > 0) {
          $form.siblings('.quantity-error').css('display', 'flex');
        }
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      if (window.Shopify && Shopify.theme && Shopify.theme.jsAjaxCart) {
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();
      }
    })
    .catch((error) => {
      console.error('Error adding to cart:', error);
    })
    .finally(() => {
      $form.find("button").attr('disabled', false);
      $form.find(".loading__spinner").addClass('hidden');
      if ($('cart-drawer').hasClass('is-empty')) {
        $('cart-drawer').removeClass('is-empty');
      }
    });
}

class CardVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.variantData = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.updateOptionsAvailability();
    this.updateMasterId();
    this.updateImage();
    this.updatePrice();
    this.updateTitle();
  }

  onVariantChange(event) {
    this.updateOptionsAvailability();
    this.updateMasterId();
    this.updateAddButton();
    this.updateImage();
    this.updatePrice();
    this.updateTitle();
  }

  // New Function: Hides options that are sold out or unavailable
  updateOptionsAvailability() {
    const selects = Array.from(this.querySelectorAll('select'));

    selects.forEach((select, selectIndex) => {
      // Loop through every option inside this dropdown
      Array.from(select.options).forEach((option) => {
        const potentialSpecs = selects.map((s, i) => {
          if (i === selectIndex) {
            return option.value; // Use the option we are testing
          } else {
            return s.value; // Use the currently selected value for others
          }
        });

        // Check if this combination exists and is available in JSON
        const match = this.variantData.find((variant) => {
          return !variant.options.map((opt, i) => potentialSpecs[i] === opt).includes(false);
        });

        if (match && match.available) {
          // It exists and is in stock: Show it
          option.disabled = false;
          option.hidden = false;
          option.innerText = option.value; // Reset text
        } else {
          // It is sold out or unavailable: Hide it
          option.disabled = true;
          option.hidden = true; // Hides it from the list
          // option.innerText = option.value + ' (Sold Out)'; // Optional: Show text instead of hiding
        }
      });
    });
  }

  updateMasterId() {
    // Get current values
    const currentOptions = Array.from(this.querySelectorAll('select'), (select) => select.value);

    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options.map((option, index) => currentOptions[index] === option).includes(false);
    });

    const form = this.closest('form');
    const input = form.querySelector('input[name="id"]');
    const quantityBlock = form.querySelector('.quantity_block');

    if (this.currentVariant) {
      input.value = this.currentVariant.id;
      input.disabled = false;

      if (quantityBlock) {
        quantityBlock.setAttribute('product-id', this.currentVariant.id);
      }
    } else {
      input.disabled = true;
    }
  }

  updateAddButton() {
    const form = this.closest('form');
    const addButton = form.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('span');

    if (!addButton) return;

    if (!this.currentVariant) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = 'Unavailable';
    } else if (!this.currentVariant.available) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = 'Sold out';
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = 'Add To Bag';
    }
  }

  updateImage() {
    if (!this.currentVariant || !this.currentVariant.featured_image) return;

    const productCard = this.closest('.product__grid-item') || this.closest('.thumbnail');
    if (!productCard) return;

    const img = productCard.querySelector('.product__imageContainer img');
    if (!img) return;

    const newImageUrl = this.currentVariant.featured_image.src;

    // Update the primary image src
    img.setAttribute('src', newImageUrl);
    
    // FIX: Remove srcset entirely so the browser doesn't force-load the old responsive images
    if (img.hasAttribute('srcset')) {
      img.removeAttribute('srcset');
    }
  }

  updatePrice() {
    if (!this.currentVariant) return;

    const priceContainer = this.closest('.product-thumbnail-button-price');
    if (!priceContainer) return;

    const priceWrapper = priceContainer.querySelector('[data-card-price-wrapper]');
    const fromLabel = priceContainer.querySelector('[data-card-price-from]');
    const priceEl = priceContainer.querySelector('[data-card-price]');
    const comparePriceWrapper = priceContainer.querySelector('[data-card-compare-price]');
    const comparePriceEl = priceContainer.querySelector('[data-card-compare-price-money]');

    if (!priceWrapper || !priceEl) return;

    const isOnSale = this.currentVariant.compare_at_price > this.currentVariant.price;

    priceWrapper.classList.toggle('sale', isOnSale);

    if (fromLabel) {
      fromLabel.hidden = true;
    }

    this.renderPrice(priceEl, this.currentVariant.price);

    if (!comparePriceWrapper || !comparePriceEl) return;

    if (isOnSale) {
      comparePriceWrapper.hidden = false;
      this.renderPrice(comparePriceEl, this.currentVariant.compare_at_price);
    } else {
      comparePriceWrapper.hidden = true;
      comparePriceEl.textContent = '';
      this.resetCurrencyAttributes(comparePriceEl);
    }
  }

  updateTitle() {
    if (!this.currentVariant) return;

    const productCard = this.closest('.product__grid-item') || this.closest('.thumbnail');
    if (!productCard) return;

    const titleEl = productCard.querySelector('.product-thumbnail__title');
    if (!titleEl) return;

    const baseTitle = productCard.dataset.productTitle || titleEl.textContent.split(' - ')[0];
    productCard.dataset.productTitle = baseTitle;

    titleEl.textContent = `${baseTitle} - ${this.currentVariant.title}`;
  }

  renderPrice(element, amount) {
    this.resetCurrencyAttributes(element);

    if (amount > 0) {
      element.classList.add('money');
      element.innerHTML = this.formatPrice(amount);
      this.updateCurrencyConversion(element);
      return;
    }

    element.classList.remove('money');
    element.textContent = (Shopify.translation && (Shopify.translation.free_price_text || Shopify.translation.free)) || 'Free';
  }

  formatPrice(amount) {
    const moneyFormat = document.body.dataset.moneyFormat
      || (window.Currency && window.Currency.money_format)
      || Shopify.money_format;

    return Shopify.formatMoney(amount, moneyFormat);
  }

  updateCurrencyConversion(element) {
    if (
      Shopify.theme
      && Shopify.theme.currencyConverter
      && typeof Shopify.theme.currencyConverter.update === 'function'
    ) {
      Shopify.theme.currencyConverter.update(element);
    }
  }

  resetCurrencyAttributes(element) {
    Array.from(element.attributes).forEach((attribute) => {
      if (attribute.name.indexOf('data-currency') === 0) {
        element.removeAttribute(attribute.name);
      }
    });
  }
}

if (!customElements.get('card-variant-selects')) {
  customElements.define('card-variant-selects', CardVariantSelects);
}
// Filetr
function toggleFilters() {
  var $sidebar = $("#filterSidebar");
  var $button = $(".filter-toggle-btn");

  $sidebar.stop(true, true).slideToggle(300); // smooth height animation
  $button.toggleClass("active");
}

$(document).ready(function () {
  $('.watch-and-shop-section .shopify-block.shopify-app-block').each(function () {

    const hasRealContent = $(this).contents().filter(function () {
      return (
        this.nodeType === 1 || // Element nodes
        (this.nodeType === 3 && $.trim(this.nodeValue) !== '') // Non-empty text nodes
      );
    }).length > 0;

    if (!hasRealContent) {
      console.log("HERE");
      $('.watch-and-shop-section').css({
        'padding': '0',
      });
    }
  });

  // Edible Ink Printer Checkbox Logic
  var $printerCheckbox = $('[data-printer-checkbox]');
  if ($printerCheckbox.length) {
    var $addToCartBtn = $('#add-to-cart-btn');
    var $variantAddToCart = $('#variant-add-to-cart');

    function updatePrinterButtons() {
      var isChecked = $printerCheckbox.prop('checked');
      $addToCartBtn.prop('disabled', !isChecked);
      $variantAddToCart.prop('disabled', !isChecked);
      if (isChecked) {
        $addToCartBtn.removeClass('disabled');
        $variantAddToCart.removeClass('disabled');
      } else {
        $addToCartBtn.addClass('disabled');
        $variantAddToCart.addClass('disabled');
      }
    }

    $printerCheckbox.on('change', updatePrinterButtons);
    updatePrinterButtons();
  }
});